export const FETCH_ALERT_HISTORY_INIT_ACTION =
  "FETCH_ALERT_HISTORY_INIT_ACTION";
export const FETCH_ALERT_HISTORY_SUCCESS_ACTION =
  FETCH_ALERT_HISTORY_INIT_ACTION + "_SUCCESS";
export const FETCH_ALERT_HISTORY_FAIL_ACTION =
  FETCH_ALERT_HISTORY_INIT_ACTION + "_ERROR";


export const FETCH_CURRENT_ALERT_INIT_ACTION =
  "FETCH_CURRENT_ALERT_INIT_ACTION";
export const FETCH_CURRENT_ALERT_SUCCESS_ACTION =
  FETCH_CURRENT_ALERT_INIT_ACTION + "_SUCCESS";
export const FETCH_CURRENT_ALERT_FAIL_ACTION =
  FETCH_CURRENT_ALERT_INIT_ACTION + "_ERROR";


  export const POST_CURRENT_ALERT_ACTION_INIT_ACTION =
  "POST_CURRENT_ALERT_ACTION_INIT_ACTION";
export const POST_CURRENT_ALERT_ACTION_SUCCESS_ACTION =
POST_CURRENT_ALERT_ACTION_INIT_ACTION + "_SUCCESS";
export const POST_CURRENT_ALERT_ACTION_FAIL_ACTION =
POST_CURRENT_ALERT_ACTION_INIT_ACTION + "_ERROR";



export const FETCH_APT_INIT_ACTION =
  "FETCH_APT_INIT_ACTION";
export const FETCH_APT_SUCCESS_ACTION =
  FETCH_APT_INIT_ACTION + "_SUCCESS";
export const FETCH_APT_FAIL_ACTION =
  FETCH_APT_INIT_ACTION + "_ERROR";